import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
} from 'axios';
import { t } from 'i18next';

import { useAuthStore } from '../stores/auth-store';
import { toaster } from '../ui/toaster';

interface AxiosRequestConfigWithMetadata<T = unknown>
  extends AxiosRequestConfig<T> {
  headers: AxiosRequestHeaders;
  metadata?: {
    startTime: number;
  };
}

interface AxiosRsponseConfigWithMetadata<T = unknown> extends AxiosResponse<T> {
  config: AxiosRequestConfigWithMetadata<T>;
}

const domain = window.location.href.includes('localhost')
  ? 'http://localhost:8085'
  : 'https://supsup-mono.onrender.com';

const supxios = axios.create({
  baseURL: `${domain}`,
  timeout: 10000,
  headers: {
    'X-Client-Origin': window.location.origin,
  },
});

supxios.interceptors.request.use((config: AxiosRequestConfigWithMetadata) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.metadata = {
    startTime: Date.now(),
  };

  return config;
});

supxios.interceptors.response.use(
  async (response: AxiosRsponseConfigWithMetadata) => {
    return response;
  },
  (error: AxiosError<{ message?: string }>) => {
    const errorKey =
      error.response?.data?.message || error.message || 'generalError';

    toaster.error({
      description: t(`error.${errorKey}`, { ns: 'common' }),
    });

    if (errorKey.includes('jwt')) {
      useAuthStore.getState().setToken(null);
      window.location.href = '/';
    }

    throw error;
  },
);

export { supxios };
